import { Reveal } from "@/components/Reveal";

// EDITÁVEL: atualize os números de impacto aqui
const NUMBERS = [
    { value: "+1000", label: "Eventos realizados", testid: "stat-eventos" },
    { value: "3×", label: "Premiada pelo Casamentos.com — anos consecutivos", testid: "stat-premios" },
    { value: "RJ", label: "Base no Rio de Janeiro, palco onde o seu evento estiver", testid: "stat-base" },
];

const Institutional = () => (
    <section id="sobre" data-testid="institutional-section" className="bg-white px-6 md:px-12 py-28 md:py-40">
        <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-12 gap-12 md:gap-8">
                <div className="md:col-span-7">
                    <Reveal>
                        <p className="text-[10px] tracking-[0.45em] uppercase text-[#6A2022] mb-8" data-testid="institutional-label">
                            A Produtora
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.95] tracking-tight" data-testid="institutional-headline">
                            Uma produtora.
                            <br />
                            Diferentes{" "}
                            <span className="font-editorial italic font-light normal-case text-[#6A2022]">
                                experiências.
                            </span>
                        </h2>
                    </Reveal>
                </div>
                <div className="md:col-span-5 flex items-end">
                    <Reveal delay={0.2}>
                        <p className="text-sm md:text-lg text-[#0A0A0A]/65 leading-relaxed max-w-md" data-testid="institutional-text">
                            A LC Production nasceu para transformar música em experiência. Reunimos
                            profissionais, produção, tecnologia e entretenimento para entregar soluções
                            completas para casamentos e eventos — do primeiro acorde da cerimônia ao
                            momento em que ninguém mais quer sair da pista.
                        </p>
                    </Reveal>
                </div>
            </div>

            <div className="mt-24 md:mt-32 grid grid-cols-1 sm:grid-cols-3 border-t border-black/10">
                {NUMBERS.map((n, i) => (
                    <Reveal key={n.testid} delay={i * 0.12} className="border-b sm:border-b-0 sm:border-r last:border-r-0 border-black/10">
                        <div className="py-10 sm:py-12 sm:px-10 first:pl-0" data-testid={n.testid}>
                            <span className="font-editorial italic font-light text-6xl md:text-7xl text-[#6A2022]">
                                {n.value}
                            </span>
                            <p className="mt-4 text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/50 leading-relaxed max-w-[220px]">
                                {n.label}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Institutional;
